module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "fixedContent"
  }, [_c('div', {
    staticClass: "clickBtn left"
  }, [_c('div', [_vm._v("下载糖糖圈app了解更多")]), _vm._v(" "), _c('div', {
    staticClass: "showCode"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "src": require("../../site/updataErcode.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "titleIntro"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("开通VIP尊享"), _c('span', {
    staticStyle: {
      "color": "#FFA71D"
    }
  }, [_vm._v("15")]), _vm._v("大权益")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish"
  }, [_vm._v("Open VIP To Enjoy 15 Major Rights")])]), _vm._v(" "), _c('div', {
    staticClass: "vipContent"
  }, [_c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip1.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("1对1血糖管理")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("糖尿病多学科医疗，一对一共同照护")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip2.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("糖豆充值返点")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("糖豆1:1等值人民币，充值越多赠送越多")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip3.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("会员商品折扣")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("会员尊享商品折扣，更低价格购买商品")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip4.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("购泵订制优惠")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("订制购泵优惠方案，糖糖圈买泵最实惠")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip5.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("付费课程折扣")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("资深调糖专家制作，高效助力自我管理")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip6.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("心愿商品清单")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("提交心愿商品清单，糖糖圈为您采购")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip7.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("共享糖化漂流")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("在家快速测糖化，省时省心更省钱")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip8.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("动态血糖云")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("搭建血糖分享网址，实现远程查看血糖")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip9.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("讲堂我做主")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("瞄准糖友痛点难点，开启会员主题讲堂")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip10.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("商品全国包邮")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("商城商品全国包邮，省心还不话冤枉钱")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip11.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("线下诊所照护")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("提前预约免费就诊，免费享多项检查")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip12.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("每月特价商品")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("商城每月特价商品，会员尊享超低优惠")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip13.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("新品优先试用")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("全球海量控糖新品，会员优先选购试用")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip14.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("会员专属头像")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("专属会员身份标示，随时随地")])]), _vm._v(" "), _c('div', {
    staticClass: "vipList left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../site/vip15.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vipTitle"
  }, [_vm._v("专属客服1对1")]), _vm._v(" "), _c('p', {
    staticClass: "vipTxt"
  }, [_vm._v("会员分配专属客服，贴心一对一解答")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "titleIntro"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("会员权益对比")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish"
  }, [_vm._v("Member rights comparison")])]), _vm._v(" "), _c('div', {
    staticClass: "vipInfo"
  }, [_c('div', {
    staticClass: "vipInfoDesc left"
  }, [_c('div', {
    staticClass: "vipInfoTitle"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "src": require("../../site/vs.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          特权对比\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("1对1血糖管理")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("糖豆充值返点")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("会员商品折扣")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("购泵订制优惠")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("付费课程折扣")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("心愿商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("共享糖化漂流")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("动态血糖云")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("讲堂我做主")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("商品全国包邮")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("线下诊所照护")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("每月特价商品")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("新品优先试用")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("会员专属头像")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("会员专属客服")])]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoDesc left",
    staticStyle: {
      "margin-left": "80px",
      "width": "267px",
      "background-color": "#fff",
      "border": "1px solid #D8D8D8"
    }
  }, [_c('div', {
    staticClass: "vipInfoTitle",
    staticStyle: {
      "background-color": "#DFE8FF"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "bottom": "15px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": require("../../site/huangguan1.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "106px"
    }
  }, [_vm._v("\n            续费制 VIP (1年)\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("密集干预"), _c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("7")]), _vm._v("天-季度回访"), _c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("4")]), _vm._v("次")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("1")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("1")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("胰岛素泵定制优惠")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("5")]), _vm._v("折优惠")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("心愿商品定制")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("一年"), _c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("1")]), _vm._v("次")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("1")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("1")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("1")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("1")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("一对一解答")])]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoDesc left",
    staticStyle: {
      "margin-left": "80px",
      "width": "267px",
      "background-color": "#fff",
      "border": "1px solid #D8D8D8"
    }
  }, [_c('div', {
    staticClass: "vipInfoTitle",
    staticStyle: {
      "background-color": "#CBFFF3"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "bottom": "15px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": require("../../site/huangguan2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "106px"
    }
  }, [_vm._v("\n            续费制 VIP (3年)\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("密集干预"), _c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("14")]), _vm._v("天-季度回访"), _c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("12")]), _vm._v("次")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("3")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("3")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("胰岛素泵定制优惠")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("4")]), _vm._v("折优惠")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("心愿商品定制")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("一年"), _c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("2")]), _vm._v("次")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("讲堂定制特权.第二次优先等级")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("3")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("3")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("3")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("3")]), _vm._v("年内有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("一对一解答")])]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoDesc left",
    staticStyle: {
      "margin-left": "80px",
      "width": "267px",
      "background-color": "#FFFAFA",
      "border": "1px solid #FF9B8A"
    }
  }, [_c('div', {
    staticClass: "vipInfoTitle",
    staticStyle: {
      "background-color": "#FFD9D6"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "top": "0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": require("../../site/tuijian.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "bottom": "15px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "src": require("../../site/huangguan3.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "106px"
    }
  }, [_vm._v("\n            终身制VIP\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("密集干预"), _c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("30")]), _vm._v("天-季度回访终身")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("终身")]), _vm._v("有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("终身")]), _vm._v("有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("胰岛素泵定制优惠")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("3")]), _vm._v("折优惠")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("心愿商品定制")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("一年"), _c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("4")]), _vm._v("次")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("免费搭建NS实现接收血糖信息")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("讲堂定制特权.第一次优先等级")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("终身免费挂号.每年一次.15项诊所服务权益")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("终身")]), _vm._v("有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("终身")]), _vm._v("有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF622B"
    }
  }, [_vm._v("终身")]), _vm._v("有效")]), _vm._v(" "), _c('div', {
    staticClass: "vipInfoTxt"
  }, [_vm._v("一对一解答")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "titleIntro"
  }, [_c('p', {
    staticClass: "titleTxt"
  }, [_vm._v("常见问题")]), _vm._v(" "), _c('p', {
    staticClass: "titleEnglish"
  }, [_vm._v("common problem")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "100px",
      "margin": "auto",
      "margin-top": "30px",
      "width": "1100px"
    }
  }, [_c('div', {
    staticClass: "problem left"
  }, [_c('p', {
    staticClass: "problemTitle"
  }, [_vm._v("1、开通糖糖圈VIP之后可以退款吗？")]), _vm._v(" "), _c('p', {
    staticClass: "problemTxt"
  }, [_vm._v("VIP为权益商品，包含服务，购买成功后立即生效，暂不接受退款，敬请谅解！")]), _vm._v(" "), _c('p', {
    staticClass: "problemTitle"
  }, [_vm._v("3、糖糖圈VIP价格会变化吗？")]), _vm._v(" "), _c('p', {
    staticClass: "problemTxt"
  }, [_vm._v("糖糖圈VIP上线初期，会有赠送活动。随着商城商品价格折扣加大、服务升级 等，VIP价格会浮动，赠送也会减少，已开通的VIP权益不受影响。越早开通， 越实惠，越早享受实惠。")]), _vm._v(" "), _c('p', {
    staticClass: "problemTitle"
  }, [_vm._v("5、糖糖圈VIP和商城会员有什么区别？")]), _vm._v(" "), _c('p', {
    staticClass: "problemTxt"
  }, [_vm._v("商城会员共有5个会员等级，通过在糖糖圈商城购物获取成长值升级（现金和 成长值的换取比例为1:1），仅在商城内购买商品可享受对应等级折扣，不涉 及商城商品外的内容。糖糖圈会员与商城会员不冲突、不共享。糖糖圈会员 通过付费购买开通会员，可享受多学科糖尿病医疗团队长期照护服务、商城 超低折扣优惠、APP专属权益等多项权益。")])]), _vm._v(" "), _c('div', {
    staticClass: "problem right"
  }, [_c('p', {
    staticClass: "problemTitle"
  }, [_vm._v("2、什么糖豆，如何获得糖豆，在哪里可以使用糖豆？")]), _vm._v(" "), _c('p', {
    staticClass: "problemTxt"
  }, [_vm._v("开通VIP后，会拥有糖豆账户，糖豆兑人民币为1:1，糖豆仅用于消费，不可 提现或转赠；开通VIP时会赠送糖豆，可通过糖豆充值活动充值并获得赠送 糖豆，同时也可以通过积分按100:1兑换糖豆；可在糖糖圈app内所有消费 场景中使用糖豆抵扣，没有使用上限。")]), _vm._v(" "), _c('p', {
    staticClass: "problemTitle"
  }, [_vm._v("4、已经购买了续费制VIP，可以升级成为终身制VIP吗？")]), _vm._v(" "), _c('p', {
    staticClass: "problemTxt"
  }, [_vm._v("在VIP有效期内，可以通过补差价升级为终身制VIP。升级后，除去原有享受 VIP权益部分，补足升级后权益。")]), _vm._v(" "), _c('p', {
    staticClass: "problemTitle"
  }, [_vm._v("6、VIP到期后，权益会立马失效吗？")]), _vm._v(" "), _c('p', {
    staticClass: "problemTxt"
  }, [_vm._v("VIP到期后，已在服务中的权益继续有效，直到服务结束。未领取的权益会自 动失效，糖豆账户中的糖豆可继续消费，直到使用完后自动关闭。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c365444","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/userInfo.vue
// module id = 188
// module chunks = 1